export default __webpack_public_path__ + "static/media/id-right_s.dbbbbefc.jpg";